/**
 * API Service
 * Central location for making API calls to the backend
 */
import axios from 'axios';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: import.meta.env.VITE_APP_URL || 'https://insuranceexpress.com',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true, // Needed for cookies/sessions
});

// Add a request interceptor
apiClient.interceptors.request.use(
  (config) => {
    // You could add auth tokens here if needed
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add a response interceptor
apiClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle common error scenarios
    if (error.response) {
      // Server responded with a status code outside of 2xx range
      console.error(`API Error: ${error.response.status}`, error.response.data);
      
      // Handle authentication errors
      if (error.response.status === 401) {
        // Could dispatch a logout action here
        console.error('Authentication error - user not authorized');
      }
      
      // Handle validation errors
      if (error.response.status === 422) {
        return Promise.reject({
          message: 'Validation failed',
          errors: error.response.data.errors
        });
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Network Error: No response received', error.request);
    } else {
      // Something happened in setting up the request
      console.error('Request Error:', error.message);
    }
    
    return Promise.reject(error);
  }
);

export default apiClient; 